const routes = [
    {
        path: '/ihaogu/day_gold_stock',
        component: function () {
            return import('@/components/admin/ihaogu/List')
        }
    }
]

export default routes
